import { AutomationFlow } from 'components/automations/containers/automationFlow';
export const SettingsAutomationsEditFlowView = AutomationFlow;
